// removed by extract-text-webpack-plugin
module.exports = {"page-front-login":"page-front-login","autofill":"autofill","login-container":"login-container","ant-input":"ant-input","ant-btn-primary":"ant-btn-primary","button-shadown":"button-shadown","btn-warning":"btn-warning","ant-btn":"ant-btn","ant-form-item-control":"ant-form-item-control","anticon":"anticon","logo-img":"logo-img","version-info":"version-info","internet-provider":"internet-provider"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/Index.scss
// module id = 315
// module chunks = 0